const flatten = [(a, b) => a.concat(b), []];

export default flatten;
